export function bytesToMegaBytes(bytes) {
  if (typeof bytes !== "number" || isNaN(bytes)) {
    throw new Error("Input must be a valid number");
  }
  return (bytes / (1024 * 1024)).toFixed(2); // returns string with 2 decimal places
}